var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOfflineA(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons/dark-UI/Offline_A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/dark-UI/Offline_A",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.96,15.803 L3.473,17.29 C2.001,16.419 1,14.831 1,13 C1,10.568 2.746,8.535 5.049,8.091 C5.439,4.561 8.082,2 11.5,2 C13.46,2 15.244,2.902 16.452,4.311 L15.038,5.724 C14.201,4.677 12.916,4 11.5,4 C8.935,4 7,6.149 7,9 L7,10 L6,10 C4.346,10 3,11.345 3,13 C3,14.287 3.819,15.378 4.96,15.803 Z M17.5,15.9997 C19.43,15.9997 21,14.4297 21,12.4997 C21,10.6817 19.4,9.1997 17.371,9.0327 L10.404,15.9997 L17.5,15.9997 Z M19.059,7.3447 C21.353,8.1177 23,10.1317 23,12.4997 C23,15.5327 20.533,17.9997 17.5,17.9997 L8.404,17.9997 L4.473,21.9307 L3.059,20.5167 L20.695,2.8807 L22.109,4.2947 L19.059,7.3447 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflineA);
export default __webpack_public_path__ + "static/media/offlineA.72049b18c7f78d8dcb9291a46c82b32a.svg";
export { ForwardRef as ReactComponent };